import { BreadCrumbs, HomeIcon } from '@isdd/idsk-ui-kit/index'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { setDocumentTitle } from '@isdd/metais-common/utils/utils'
import { RouteNames } from '@isdd/metais-common/navigation/routeNames'

import { getCiHowToBreadCrumb, useGetEntityParamsFromUrl } from '@/componentHelpers/ci'
import { MainContentWrapper } from '@/components/MainContentWrapper'
import { useCiCreateEntityHook } from '@/hooks/useCiCreateEntity.hook'
import { EvidenceObjectAttributeCreateContainer } from '@/components/containers/evidence-object-attribute/EvidenceObjectAttributeCreateContainer'

const CreateAtributObjektuEvidenciePage: React.FC = () => {
    const { t } = useTranslation()
    const { entityName } = useGetEntityParamsFromUrl()
    const ciCreateData = useCiCreateEntityHook({ entityName: entityName ?? '' })

    setDocumentTitle(t('titles.ciCreateEntity', { ci: ciCreateData.ciTypeName }))

    return (
        <>
            <BreadCrumbs
                withWidthContainer
                links={[
                    { label: t('breadcrumbs.home'), href: '/', icon: HomeIcon },
                    ...getCiHowToBreadCrumb(entityName ?? '', t),
                    { label: t('breadcrumbs.wiki.REGISTER_DATA_RIGHTS_OBLIGATIONS'), href: RouteNames.REGISTER_DATA_RIGHTS_OBLIGATIONS },
                    {
                        label: t('titles.ciList', { ci: ciCreateData.ciTypeName }) ?? '',
                        href: `/ci/${entityName}`,
                    },
                    {
                        label: t('breadcrumbs.ciCreateEntity', { entityName: ciCreateData.data.attributesData.ciTypeData?.name }),
                        href: `/ci/create`,
                    },
                ]}
            />
            <MainContentWrapper>
                <EvidenceObjectAttributeCreateContainer {...ciCreateData} />
            </MainContentWrapper>
        </>
    )
}

export default CreateAtributObjektuEvidenciePage
